class BrandsListContainer {
  constructor(
    $element,
    $timeout,
    appErrorHandler,
    appEvents,
    appSectionsStorage,
    locationUtils,
    brands,
    BRANDS_EVENTS,
  ) {
    'ngInject';

    [this.$element] = Array.from($element);
    this.$timeout = $timeout;
    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.locationUtils = locationUtils;
    this.BRANDS_EVENTS = BRANDS_EVENTS;
    this.shouldTriggerInitialFetch = false;
    this.mainList = appSectionsStorage.store(
      'brands',
      'mainList',
      () => {
        this.shouldTriggerInitialFetch = true;
        return brands.newList();
      },
    );
    this.searchList = brands.newList();
    this.searchQuery = '';
    this.listsDisplayProperties = {
      label: {
        withDetail: 'name',
        withoutDetail: 'name',
      },
      detail: 'photorank_id',
      hasDetail: 'id',
    };
    this.listsEnabled = true;

    this.selectionRoute = '/accounts/';
    this.removeSelectionSubscription = this.appEvents.on(
      this.BRANDS_EVENTS.select,
      (brand) => {
        this.selectedId = brand.id;
      },
    );
    this.removeSelectionLoadSubscription = this.appEvents.on(
      this.BRANDS_EVENTS.load.start,
      () => this.disableLists(),
    );
    this.removeSelectionFinishSubscription = this.appEvents.on(
      this.BRANDS_EVENTS.load.finish,
      () => this.enableLists(),
    );
    this._searchboxSelector = '[data-list-searchbox] input[type="text"]';
  }
  $onInit() {
    if (this.shouldTriggerInitialFetch) {
      this.fetchMoreFromMainList();
    }
  }
  $onDestroy() {
    this.removeSelectionSubscription();
    this.removeSelectionLoadSubscription();
    this.removeSelectionFinishSubscription();
  }
  disableLists() {
    this.listsEnabled = false;
  }
  enableLists() {
    this.listsEnabled = true;
  }
  fetchMoreFromMainList() {
    return this.mainList
    .fetch()
    .catch((error) => {
      this.appErrorHandler.handle(error, 'There was an error loading the accounts list');
    });
  }
  fetchMoreFromSearchList() {
    return this.searchList
    .fetch(this.searchQuery)
    .catch((error) => {
      this.appErrorHandler.handle(error, 'There was an error loading the search results');
    });
  }
  search(text) {
    if (text !== this.searchQuery) {
      this.searchQuery = text;
      if (this.searchQuery) {
        this.searchList.fetch(this.searchQuery)
        .then(() => this.setSearchboxFocus())
        .catch((error) => {
          this.appErrorHandler.handle(error, 'There was an error loading the search results');
        });
      }
    }
  }
  setSearchboxFocus() {
    this.$timeout(() => {
      this.$element.querySelector(this._searchboxSelector).focus();
    });
  }
  selectBrand($event, item) {
    $event.preventDefault();
    if (item.id !== this.selectedId) {
      this.locationUtils.skipReload().path(`${this.selectionRoute}${item.id}`);
      this.appEvents.emit(this.BRANDS_EVENTS.select, item);
    }
  }
}

export default {
  controller: BrandsListContainer,
  template: `
    <div class="flex-column">
      <searchbox
        id="searchFilter"
        max-length="50"
        on-search="$ctrl.search(text)"
        disable-search="($ctrl.mainList.fetching || $ctrl.searchList.fetching)"
        data-list-searchbox
      ></searchbox>
      <selection-list
        class="flex-column"
        ng-if="!$ctrl.searchQuery"
        items="$ctrl.mainList.items"
        items-display-properties="$ctrl.listsDisplayProperties"
        items-route="{{::$ctrl.selectionRoute}}"
        selected-item-id="$ctrl.selectedId"
        total="$ctrl.mainList.total"
        loading="$ctrl.mainList.fetching"
        items-per-page="$ctrl.mainList.itemsPerPage"
        disable-selection="!$ctrl.listsEnabled"
        on-request-more-items="$ctrl.fetchMoreFromMainList()"
        on-item-selection="$ctrl.selectBrand($event, item)"
      ></selection-list>
      <selection-list
        class="flex-column"
        ng-if="$ctrl.searchQuery"
        items="$ctrl.searchList.items"
        items-display-properties="$ctrl.listsDisplayProperties"
        items-route="{{::$ctrl.selectionRoute}}"
        selected-item-id="$ctrl.selectedId"
        total="$ctrl.searchList.total"
        loading="$ctrl.searchList.fetching"
        items-per-page="$ctrl.searchList.itemsPerPage"
        disable-selection="!$ctrl.listsEnabled"
        on-request-more-items="$ctrl.fetchMoreFromSearchList()"
        custom-no-results-message="No results found"
        on-item-selection="$ctrl.selectBrand($event, item)"
      ></selection-list>
    </div>
  `,
  bindings: {
    selectedId: '<',
  },
};
